<template>
  <div
    id="register-step-1"
    class="vertical-fill"
  >
    <div class="title">
      {{ $t('view-Register-step1.title') }}
    </div>

    <router-link :to="{name: 'register-step2', params: {type: 'a'}}">
      <span v-html="$t('view-Register-step1.reg-option-1')" />
      <span>
        <img
          :src="$publicPath + 'img/brand.png'"
          width="190"
          height="190"
        >
      </span>
    </router-link>
    <router-link :to="{name: 'register-step2', params: {type: 'i'}}">
      <span v-html="$t('view-Register-step1.reg-option-2')" />
      <span>
        <img
          :src="$publicPath + 'img/influencer.png'"
          width="190"
          height="190"
        >
      </span>
    </router-link>
  </div>
</template>

<script>
export default {
}
</script>

<style scoped lang="scss">
  #register-step-1 {
    a {
      margin-top: 1.6rem;
      font-size: 1.35rem;
      color: inherit;
      display: flex;
      flex-direction: column;
      line-height: 105%;
      img {
        transition: 0.3s;
        max-width: 190px;
      }
      &:hover {
        text-decoration: none;
        img {
          transform: scale(1.1);
        }
      }
    }
  }
</style>
